<template>
    <div class="flex justify-between items-center w-full gap-4 3xl:gap-8
                py-3 border-t border-gray-50 dark:border-gray-900/50 
                first:!border-0 group-first/item:!border-t-0
                text-base lg:text-lg 3xl:text-2xl">
        <slot></slot>
    </div>
</template>